<template>
    <div class="page-content">
        <SidebarLayout :active-menu="activeMenu">
            <template #submenu>
                <slot name="submenu"></slot>
            </template>
        </SidebarLayout>

        <div class="page-inner bg-linear">
            <div class="page-wrap">
                <div class="main-content-wrap">
                    <div class="main-content">
                        <!-- Page Breadcrumbs -->
                        <slot name="breadcrumbs"></slot>
                    </div>
                    <!-- Page Header -->
                    <div class="row g-0">
                        <div class="col-sm">
                            <div class="title-col2">
                                <slot name="pageTitle"></slot>
                            </div>
                            <div class="search-bar">
                                <slot name="search"></slot>
                            </div>
                        </div>
                        <!-- Page Header Button -->
                        <div class="col-sm-auto">
                            <div class="btn-col mt-3 mt-sm-0">
                                <slot name="headerButton"></slot>
                            </div>
                        </div>
                    </div>
                    <div class="row g-0">
                        <!-- Page Content -->
                        <div class="col-lg content-wrap">
                            <slot></slot>
                        </div>
                        <!-- Page Right Sidebar -->
                        <div class="col-lg-auto">
                            <slot name="rightSidebar"></slot>
                        </div>
                    </div>

                    <!-- Modal Portal -->
                    <portal-target name="modal" multiple>
                    </portal-target>
                </div>
                <!-- Footer -->
                <div class="footer-wrap">
                    <div class="footer-nav">
                        <a href="https://helmbay.com/terms-of-service/" target="_blank">Terms of service</a>
                        <a href="https://helmbay.com/privacy-policy/" target="_blank">Privacy policy</a>
                        <a href="https://helmbay.com/imprint/" target="_blank">Imprint</a>
                    </div>
                    <div class="copyright">
                        <span>&copy; 2021 Helmbay</span>
                        <span>All rights reserved</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import JetApplicationMark from '@/Jetstream/ApplicationMark'
    import JetBanner from '@/Jetstream/Banner'
    import JetDropdown from '@/Jetstream/Dropdown'
    import JetDropdownLink from '@/Jetstream/DropdownLink'
    import JetNavLink from '@/Jetstream/NavLink'
    import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
    import SidebarLayout from '@/Layouts/SidebarLayout'

    export default {
        components: {
            JetApplicationMark,
            JetBanner,
            JetDropdown,
            JetDropdownLink,
            JetNavLink,
            JetResponsiveNavLink,
            SidebarLayout,
        },

        props: {
            activeMenu: {
                default: "repositories"
            }
        },

        data() {
            return {
                showingNavigationDropdown: false,
            }
        },

        methods: {
            switchToTeam(team) {
                this.$inertia.put(route('current-team.update'), {
                    'team_id': team.id
                }, {
                    preserveState: false
                })
            },

            logout() {
                this.$inertia.post(route('logout'));
            },
        }
    }
</script>
